import {
	ActionTypes,
	SEARCH_BARCODE_FULFILLED,
	SEARCH_BARCODE,
} from '../types'

interface BarcodeState {
	busy: boolean
	code: string | null
}

const initialState = {
	busy: false,
	code: null,
}

export default function reducer(state: BarcodeState = initialState, action: ActionTypes): BarcodeState {
	switch (action.type) {
		case SEARCH_BARCODE:
			return {
				busy: true,
				code: action.payload.barcode,
			}

		case SEARCH_BARCODE_FULFILLED:
			return {
				...state,
				busy: false,
			}

		default:
			return state
	}
}
